module.exports = __webpack_public_path__ + "static/media/Violation tooth angulation6.0c19e202.png";